export default __webpack_public_path__ + "static/media/laconic_main.645c25cc.jpg";